import { API_ENDPOINTS } from 'services/api';
import httpClient from 'services/httpClient';
import { ReviewMasterPlanFormData } from 'types/dacum/reviewMasterplan';
import { CreateMasterPlanPayload, CreateMasterPlanResponse } from 'types/dacum/masterPlan';

interface Params {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  jobband?: string;
  jobfamilyid?: string;
  division?: string;
  onlyUnassigned?: number;
}

interface DefaultResponse {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  message: string;
}

interface ReviewMasterPlanResponse extends DefaultResponse {
  data: ReviewMasterPlanFormData[];
}

interface KeyActionCompetencyResponse extends DefaultResponse {
  data: {
    level: number;
    description: string;
  }[];
}

export const reviewMasterPlanService = {
  getReviewMasterPlan: async (params?: Params): Promise<ReviewMasterPlanResponse> => {
    const response = await httpClient.get<ReviewMasterPlanResponse>(
      API_ENDPOINTS.DACUM.REVIEW_MASTERPLAN.LIST,
      {
        params
      }
    );
    return response.data;
  },
  getKeyActionCompetency: async (params?: {
    competencyId: string;
    pageNumber: number;
    pageSize: number;
  }): Promise<KeyActionCompetencyResponse> => {
    const response = await httpClient.get<KeyActionCompetencyResponse>(
      API_ENDPOINTS.DACUM.REVIEW_MASTERPLAN.KEYACTION_LIST,
      {
        params
      }
    );
    return response.data;
  },
  createMasterPlan: async (payload: CreateMasterPlanPayload): Promise<CreateMasterPlanResponse> => {
    const response = await httpClient.post<CreateMasterPlanResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.ADD,
      payload
    );
    return response.data;
  }
};
